import { render } from "./chooselaundryroom.vue?vue&type=template&id=0cb245da"
import script from "./chooselaundryroom.vue?vue&type=script&lang=js"
export * from "./chooselaundryroom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__